<template>
  <div class="page pygn">
    
    <div :class="contentClass" :style="bgimg" v-if="!contentPage">
      <div class="tab-title">
        <img :src="title">
      </div>
      <div class="content-show" @click="contentPage = true">
        <span :class="lngClass">{{ $t("base.view-details") }}</span>
        <img src="@/assets/img/content-show.png">
      </div>
    </div>
    
    <BottomNav
      :page="page"
      :items="tabs"
      :active="currentTab"
      :class="lngClass"
      btnclass="pygn-nav"
      @changeNav="changeTab"
      wrap
    ></BottomNav>

    <transition name="slide">
      <div
        class="content-page"
        :style="bgimg"
        v-if="contentPage"
      >
        <m-textarea>
          <div v-html="content"></div>
        </m-textarea>
        <Arrow class="btn-arrow" type="back" @arrowClick="contentPage = false"></Arrow>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import BottomNav from "@/components/BottomNav.vue";
import TextArea from "@/components/TextArea.vue";
import Arrow from "@/components/Arrow.vue";

export default {
  components: {
    BottomNav,
    "m-textarea": TextArea,
    Arrow
  },
  data() {
    return {
      page: "pygn",
      currentTab: 0,
      curretTabName: "wsgn",
      contentPage: false
    };
  },
  computed: {
    ...mapState({
      tabs: state => state.tabs.pygn,
      pygn: "pygn"
    }),
    ...mapGetters(["lngClass"]),
    bgimg() {
      const bg = this.tabs[this.currentTab].bgimg;
      return { backgroundImage: `url("${bg}")` };
    },
    contentClass() {
      return `${this.page}-tabs`;
    },
    content() {
      const tabData = this.pygn[this.curretTabName];
      return tabData ? tabData.content : "";
    },
    title() {
      return this.tabs[this.currentTab].ttimg;
    }
  },
  mounted() {
    this.getContent({
      page: this.page,
      tab: "wsgn"
    });
  },
  methods: {
    ...mapActions(["getContent"]),
    changeTab(activeNum) {
      const tabName = this.tabs[activeNum].name;
      this.getContent({
        page: this.page,
        tab: tabName
      });
      this.currentTab = activeNum;
      this.curretTabName = tabName;
    }
  }
};
</script>

<style lang="scss">
@import "../assets/base";

.pygn {
  .pygn-nav {
    @include tab1;
  }

  .lng {
    .pygn-nav {
      width: 20vw;
    }
  }

  .content-page {
    @include full-box;
    position: relative;
    height: 100vh;
    z-index: 30;
    padding: 2rem;
    background-position-x: right;
    background-size: cover;

    .textarea {
      height: 70vh;

      .text-main {
        padding-right: 1rem;
      }
    }

    .btn-arrow {
      margin-top: 1.5rem;
      margin-left: -1rem;
    }
  }
}

.pygn-tabs {
  position: relative;
  height: 100vh;
  background-size: cover;

  .tab-title {
    position: relative;
    left: 2rem;
    top: 4rem;
    @include scaleimg(0.5);
  }

  @media (max-width: 320px) {
    .tab-title {
      transform: scale(0.45);
    }
  }

  .content-show {
    display: flex;
    align-items: center;
    position: absolute;
    right: 0.5rem;
    top: 30%;

    span {
      display: inline-block;
      width: 1em;
      line-height: 1;
      color: #6b6b6b;
      vertical-align: middle;

      &.lng {
        width: auto;
      }
    }

    @include img-fluid;
    img {
      flex: none;
      display: block;
      width: 0.65rem;
      height: 2rem;
    }
  }
}
</style>
